import { useState } from 'react';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { PlusIcon } from 'framework/ui/mui-builder';
import { useAuthorization } from 'framework/authorization';
import { RISK_CREATE_TIMELINE_ENTRY } from 'domain/shared/newProject';
import { AddTimelineItemInputProps } from 'domain/shared/timeline/person/PersonTimelinePageLayout';

const RiskTimelineActionsButton = ({ registries, selectItemCallback }: AddTimelineItemInputProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const noteRegistry = registries?.find(r => r.name === 'Note');
  const { isGranted } = useAuthorization();

  const handleClose = () => setAnchorEl(null);

  const handleAddNote = () => {
    handleClose();
    if (noteRegistry) selectItemCallback(noteRegistry);
  };

  if (!isGranted(RISK_CREATE_TIMELINE_ENTRY)) {
    return null;
  }

  return (
    <>
      <IconButton onClick={handleAddNote}>
        <PlusIcon color="primary" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        sx={{ '& .MuiPaper-root': { minWidth: 160 } }}
      >
        <MenuItem onClick={handleAddNote}>Add note</MenuItem>
      </Menu>
    </>
  );
};
export default RiskTimelineActionsButton;
